<script setup lang="ts">
/** One stat as the kit draws a value: painted icon, label, the figure in a chip and a glossy amber bar (`KitRow`'s). */
import GameIcon from '@/ui/kit/GameIcon.vue';
import type { GameIconName } from '@/ui/kit/icons';

defineProps<{ icon: GameIconName; label: string; value: string; ratio: number }>();
</script>

<template>
  <div class="stat">
    <GameIcon :name="icon" :size="40" />
    <div class="body">
      <div class="top">
        <span class="k-label name">{{ label }}</span>
        <span class="k-chip val">{{ value }}</span>
      </div>
      <span class="bar" aria-hidden="true"><span class="fill" :style="{ '--v': Math.max(0.04, Math.min(1, ratio)) }"></span></span>
    </div>
  </div>
</template>

<style scoped>
.stat {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.body {
  display: grid;
  gap: 5px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.name {
  font-size: 0.95rem;
  text-transform: uppercase;
}

.val {
  padding: 0.1rem 0.7rem;
  font-size: 1rem;
}

.bar {
  position: relative;
  height: 14px;
  border-radius: 999px;
  background: #070c12;
  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.8), 0 1px 0 rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.fill {
  position: absolute;
  inset: 2px auto 2px 2px;
  width: calc((100% - 4px) * var(--v));
  border-radius: 999px;
  background: linear-gradient(180deg, #ffe08a, #f0a92a 55%, #c47a12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  transition: width 600ms var(--ease);
}
</style>
